import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
import { SEO } from './components/SEO';
export function App() {
  useEffect(() => {
    // Add Google Analytics gtag script
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-8F0SLFHEXR';
    document.head.appendChild(script1);
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-8F0SLFHEXR');
    `;
    document.head.appendChild(script2);
  }, []);
  return <>
      <SEO data-id="element-0" />
      <LandingPage data-id="element-1" />
    </>;
}